//styles
import * as S from './DetailsPageLoader.styles';

const DetailsTopLoader = () => (
  <S.DetailsPageLoaderWrapper>
    <div className="dlLoader">
      <div className="hotelDetailsWrapper">
        <div className="hotelDetailsWrapperInner dl_Container">
          <ul className="dl_breadcrumb appendBottom30">
            <li />
            <li />
            <li />
          </ul>
          <div className="makeFlex spaceBetween appendBottom30">
            <div className="dl_hotelName">
              <h4 />
              <p />
            </div>
            <div className="dl_map">
              <div className="dl_map_left" />
              <div className="dl_map_Right">
                <div className="dl_map_top" />
                <div className="dl_map_bottom" />
              </div>
            </div>
          </div>

          <div className="makeFlex spaceBetween appendBottom30">
            <div className="dl_left" />
            <div className="dl_middle">
              <div className="dl_video" />
            </div>
            <div className="dl_right">
              <div className="dl_right_top">
                <p />
                <p />
                <p />
                <p />
                <p />
                <p />
                <p />
              </div>
              <div className="dl_right_bottom">
                <p />
                <p />
                <p />
                <p />
                <p />
              </div>
            </div>
          </div>
        </div>
        <div className="dl_Section">
          <div className="dl_SectionInner dl_Container">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
      <DetailsBottomLoader />
      <div className="appendBottom30"></div>
    </div>
  </S.DetailsPageLoaderWrapper>
);

export const DetailsBottomLoader = () => {
  return (
    <S.DetailsPageLoaderWrapper>
      <div className="dl_roomFiltersContainer dl_Container">
        <ul className="dl_List appendBottom30">
          <li>
            <span />
            <span />
          </li>
          <li>
            <span />
            <span />
          </li>
          <li>
            <span />
            <span />
          </li>
          <li>
            <span />
            <span />
          </li>
          <li>
            <span />
            <span />
          </li>
        </ul>
      </div>

      <div className="dl_comboRoom">
        <div className="dl_comboRoom_top">
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
        </div>
        <div className="dl_comboRoom_bottom">
          <div>
            <h4 />
            <span className="dl_ImgCont" />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
        </div>
      </div>
      <div className="dl_comboRoom">
        <div className="dl_comboRoom_top">
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
          <div>
            <span />
          </div>
        </div>
        <div className="dl_comboRoom_bottom">
          <div>
            <h4 />
            <span className="dl_ImgCont" />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
          <div>
            <p />
            <p />
            <p />
            <p />
            <p />
            <p />
          </div>
        </div>
      </div>
    </S.DetailsPageLoaderWrapper>
  );
};

export default DetailsTopLoader;
